// Custom Alert System
(function() {
  'use strict';
  
  var alertModal = null;
  var isOpen = false;

  // HTMLテンプレート
  var ALERT_TEMPLATE = `
    <div id="custom-alert" class="alert-overlay" role="dialog" aria-modal="true" aria-hidden="true">
      <div class="alert-content">
        <button type="button" class="alert-close" aria-label="閉じる">&times;</button>
        <div class="alert-message"></div>
      </div>
    </div>
  `;

  // モーダル作成
  function createAlertModal() {
    if (document.getElementById('custom-alert')) {
      alertModal = document.getElementById('custom-alert');
      return;
    }

    document.body.insertAdjacentHTML('beforeend', ALERT_TEMPLATE);
    alertModal = document.getElementById('custom-alert');
    bindEvents();
  }

  // イベントバインド
  function bindEvents() {
    // 閉じるボタン
    var closeBtn = alertModal.querySelector('.alert-close');
    closeBtn.addEventListener('click', hideAlert);
    
    // オーバーレイクリック
    alertModal.addEventListener('click', function(e) {
      if (e.target === alertModal) {
        hideAlert();
      }
    });

    // Escキー
    document.addEventListener('keydown', function(e) {
      if (isOpen && e.key === 'Escape') {
        hideAlert();
      }
    });
  }

  // アラート表示
  function showAlert(message) {
    if (!message) return;

    // モーダル作成
    createAlertModal();

    // メッセージ設定
    var messageEl = alertModal.querySelector('.alert-message');
    messageEl.textContent = message;

    // 表示
    alertModal.setAttribute('aria-hidden', 'false');
    alertModal.classList.add('show');
    
    // スクロール無効
    document.body.style.overflow = 'hidden';
    
    // フォーカス
    var closeBtn = alertModal.querySelector('.alert-close');
    closeBtn.focus();
    
    isOpen = true;
  }

  // アラート非表示
  function hideAlert() {
    if (!isOpen || !alertModal) return;

    alertModal.classList.remove('show');
    alertModal.setAttribute('aria-hidden', 'true');
    
    // スクロール復帰
    document.body.style.overflow = '';
    
    isOpen = false;
  }

  // グローバル関数として公開
  window.customAlert = showAlert;
  window.showMessage = showAlert;

  // 既存のalert関数を置き換える場合（オプション）
  window.alert = showAlert;

})();